import { AdditionalHtsType } from '@xbcb/trade-data-types';
import { HtsObject } from 'types';

export const section232SteelInfoEffectiveDate = new Date('2024-11-21');

export const isSection232SteelMeltAndPourApplicableForAnyTariff: (
  htsObjects: (HtsObject | undefined)[],
  estimatedImportDate: Date | undefined,
  // Hydra master bookings carry no import date (their Transportation tab is
  // hidden), so callers pass true to go by HTS alone.
  skipImportDateCheck?: boolean,
) => boolean = (
  htsObjects,
  estimatedImportDate,
  skipImportDateCheck = false,
) => {
  return htsObjects.some((tariff) =>
    Boolean(
      containsAdditionalHtsWithSection232SteelType(tariff) &&
        (skipImportDateCheck ||
          estimatedImportDateIsOnOrAfterEffectiveDate(estimatedImportDate)),
    ),
  );
};

const section232SteelTypes = new Set([
  AdditionalHtsType.SECTION_232_STEEL,
  AdditionalHtsType.SECTION_232_METAL,
  AdditionalHtsType.SECTION_232_METAL_EXCLUSION,
]);

const containsAdditionalHtsWithSection232SteelType: (
  hts?: HtsObject,
) => boolean = (hts) => {
  return Boolean(
    hts?.additional?.some((additionalHts) =>
      section232SteelTypes.has(additionalHts?.type as AdditionalHtsType),
    ),
  );
};

const estimatedImportDateIsOnOrAfterEffectiveDate: (
  estimatedImportDate: Date | undefined,
) => boolean = (estimatedImportDate) => {
  return Boolean(
    estimatedImportDate &&
      estimatedImportDate >= section232SteelInfoEffectiveDate,
  );
};

const section232SteelTariffType = AdditionalHtsType.SECTION_232_STEEL;
